import type { PageStateType } from '@confluence/page-context';

export type ContentType = PageStateType['contentType'];

export const isPageOrBlogPost = (contentType: ContentType): contentType is 'page' | 'blogpost' => {
	return contentType === 'page' || contentType === 'blogpost';
};
